const elementAppend = ({ parent, child }) => {
  if (!parent) {
    return false;
  }

  if (!child) {
    return false;
  }

  return parent.appendChild(child);
};

// noinspection JSUnusedGlobalSymbols
export default elementAppend;
